import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/ru";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useStore } from "../hooks/store";
import { getCategory, getLesson } from "../utils/API/schoolMethods";

import { drivingLesson } from "../utils/config";
import { usePortal } from "../hooks/usePortal";
import EpmtyAgenda from "./ReactCalendarComponents/EpmtyAgenda";
import LessonEvent from "./ReactCalendarComponents/LessonEvent";
import LessonUnavalible from "./ReactCalendarComponents/LessonsUnavalible";

import DrivingLessonForm from "./Form/DrivingLessonForm";
import { getSchool, getSchoolGroup } from "../utils/API/schoolMethods";
import { getDrivingTime, getUserBySchool } from "../utils/API/userMethods";
import AgendaEvent from "./ReactCalendarComponents/AgendaEvent";

moment.locale("ru");
const localizer = momentLocalizer(moment);

export default function ReactCalendar({
  currentSchoolId,
  currentTeacher,
  currentStudent,
  practiceEnable,
}) {
  const store = useStore();
  const loading = usePortal();
  const [categoryList, setCategoryList] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [agendaLength] = useState(7);

  const fetchLesson = async () => {
    const teacherId = currentTeacher ? currentTeacher.id : null;
    const studentId = currentStudent ? currentStudent.id : null;
    const categoryRes = await getCategory();
    const lessonRes = await getLesson(studentId, teacherId, currentSchoolId);

    if (lessonRes.status === 200) {
      setLessons(
        lessonRes.data.map((lesson) => ({
          ...lesson,
          title: drivingLesson[lesson.lesson_type].title,
          start: new Date(lesson.lesson_start_time),
          end: new Date(lesson.lesson_end_time),
        })),
      );
    }

    if (categoryRes.status === 200) {
      setCategoryList(categoryRes.data);
    }
  };

  useEffect(() => {
    fetchLesson();
  }, [currentTeacher, currentStudent]);

  const handleRenderLessonEvent = ({ event }) => {
    return <LessonEvent event={event} categoryList={categoryList} />;
  };

  const AgendaEventRender = ({ event }) => {
    return <AgendaEvent event={event} categoryList={categoryList} />;
  };

  const eventPropGetter = (lessonData, start) => {
    const typeConfig = drivingLesson[lessonData.lesson_type];
    const baseColor = typeConfig?.color || "#90A4AE";
    const baseSoftColor = typeConfig?.colorSoft || "#d2d2d4";
    const isAgenda = !start;
    const isBooked = !!lessonData.student_id;

    if (isAgenda) {
      return {
        style: {
          backgroundColor: "transparent",
          border: "none",
          color: "inherit",
        },
      };
    }

    const style = {
      // ПОЖЕЛАНИЕ: Свободный слот - полупрозрачный, Занятый - полностью закрашен
      backgroundColor: isBooked ? baseColor : baseSoftColor,
      border: `1.5px solid ${baseColor}`,
      borderRadius: "6px",
      color: isBooked ? "white" : "#000", // Контраст шрифта в зависимости от заливки
      display: "block",
      boxSizing: "border-box",
    };

    // Статус "Отменено" (3)
    if (lessonData.lesson_status === 3) {
      style.opacity = 0.4;
      style.textDecoration = "line-through";
    }

    // ПОЖЕЛАНИЕ: Выделяющийся прерывистый бордер для неподтвержденных (статус 0)
    if (lessonData.lesson_status === 0 && isBooked) {
      style.border = "3px dashed #FFD600"; // Ярко-желтый и толще
    }

    return { style };
  };

  const handleAddOpener = async (event) => {
    loading.setPortal();
    const { start, end, lesson_type } = event;
    const schoolList = await getSchool();
    const groupList = await getSchoolGroup(currentSchoolId);

    const filtredStudentList = [];
    const filtredTeacherList = [];
    const filtredCategoryList = [];

    if (currentTeacher) {
      filtredTeacherList.push(currentTeacher);
      groupList.data.forEach((group) => {
        //Берем только тех учеников, которые состоят в одной группе с учителем

        group.grouped_users.find(
          (u) => Number(u.id) === Number(currentTeacher.id),
        ) &&
          filtredStudentList.push(
            group.grouped_users.filter((u) => u.role === 1),
          );
      });
    } else if (currentStudent) {
      filtredStudentList.push(currentStudent);
      const userGroup = groupList.data.find((group) =>
        group.grouped_users.find(
          (u) => Number(u.id) === Number(currentStudent.id),
        ),
      );
      filtredTeacherList.push(
        userGroup.grouped_users.filter((u) => u.role === 5),
      );

      const drivingTime = await getDrivingTime(currentStudent.id);

      if (drivingTime.status === 200) {
        drivingTime.data.forEach((timeRecord) => {
          filtredCategoryList.push({
            id: timeRecord.category_id,
            name: timeRecord.name,
          });
        });
      }
    } else {
      groupList.data.forEach((group) => {
        group.grouped_users.forEach(
          (u) => u.role === 5 && filtredTeacherList.push(u),
        );
      });
    }

    store.setForm(<DrivingLessonForm />, fetchLesson, {
      // studentData: currentStudent || null,
      // teacherteacher: currentTeacher || null,
      student_id: (currentStudent && currentStudent.id) || null,
      teacher_id: (currentTeacher && currentTeacher.id) || null,
      school_id: currentSchoolId,
      lesson_type,
      currentTeacher,
      currentStudent,
      schoolList: schoolList.status == 200 ? schoolList.data : [],
      // teacherList: currentTeacher ? [currentTeacher] : filtredTeacherList,
      teacherList: filtredTeacherList.flat(1),
      studentList: filtredStudentList.flat(1),
      lesson_start_time: start,
      lesson_end_time: end,
      // categoryList: customCategories || categoryList.data || [],
      categoryList: filtredCategoryList,
      groupList: groupList.data,
    });

    loading.closePortal();
  };

  const handleRedactOpener = async (event) => {
    loading.setPortal();

    const {
      start,
      end,
      id,
      lesson_status,
      lesson_type,
      school_id,
      student_id,
      teacher_id,
      category_id,
    } = event;

    const schoolList = await getSchool();
    const userList = await getUserBySchool(currentSchoolId);
    const groupList = await getSchoolGroup(currentSchoolId);
    const categoryList = await getCategory();

    const filtredStudentList = [];
    const filtredTeacherList = [];
    const filtredCategoryList = [];

    if (currentTeacher) {
      filtredTeacherList.push(currentTeacher);
      groupList.data.forEach((group) => {
        //Берем только тех учеников, которые состоят в одной группе с учителем

        group.grouped_users.find(
          (u) => Number(u.id) === Number(currentTeacher.id),
        ) &&
          filtredStudentList.push(
            group.grouped_users.filter((u) => u.role === 1),
          );
      });
    } else if (currentStudent) {
      filtredStudentList.push(currentStudent);
      const userGroup = groupList.data.find((group) =>
        group.grouped_users.find(
          (u) => Number(u.id) === Number(currentStudent.id),
        ),
      );

      filtredTeacherList.push(
        userGroup.grouped_users.filter((u) => u.role === 5),
      );

      const drivingTime = await getDrivingTime(currentStudent.id);

      if (drivingTime.status === 200) {
        drivingTime.data.forEach((timeRecord) => {
          filtredCategoryList.push({
            id: timeRecord.category_id,
            name: timeRecord.name,
          });
        });
      }
    } else {
      groupList.data.forEach((group) => {
        group.grouped_users.forEach(
          (u) => u.role === 5 && filtredTeacherList.push(u),
        );
      });
    }
    if (student_id) {
      const studentDrivingTime = await getDrivingTime(student_id);

      if (studentDrivingTime.status === 200) {
        studentDrivingTime.data.forEach((DTRecord) => {
          filtredCategoryList.push({
            id: DTRecord.category_id,
            name: DTRecord.name,
          });
        });
      } else {
        studentDrivingTime.push({ id: "", name: "Ошибка получения категорий" });
      }

      groupList.data.forEach((group) => {
        //Берем только тех учеников, которые состоят в одной группе с учителем

        group.grouped_users.find((u) => Number(u.id) === Number(teacher_id)) &&
          filtredStudentList.push(
            group.grouped_users.filter((u) => u.role === 1),
          );
      });
    }

    store.setForm(<DrivingLessonForm />, fetchLesson, {
      id,
      student_id: student_id,
      teacher_id: teacher_id,
      school_id: school_id,
      category_id: category_id,
      lesson_type,
      lesson_status,
      currentStudent: currentStudent || null,
      currentTeacher: currentTeacher || null,
      schoolList: schoolList.status == 200 ? schoolList.data : [],
      teacherList: filtredTeacherList.flat(1),
      studentList: filtredStudentList.flat(1),
      lesson_start_time: start,
      lesson_end_time: end,
      categoryList: filtredCategoryList || categoryList.data || [],
      groupList: groupList.data,
    });
    loading.closePortal();
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      <h6 style={{ justifySelf: "start", width: "100%", margin: "20px 0" }}>
        Календарь практических занятий
      </h6>

      <div style={{ width: "100%", position: "relative" }}>
        {!Boolean(Number(practiceEnable)) && !currentTeacher && (
          <LessonUnavalible />
        )}

        <Calendar
          selectable={Boolean(Number(practiceEnable)) || !!currentTeacher}
          localizer={localizer}
          onSelectSlot={handleAddOpener}
          onSelectEvent={handleRedactOpener}
          events={lessons}
          startAccessor="start"
          endAccessor="end"
          defaultView="week"
          views={["day", "week", "agenda"]}
          step={30}
          timeslots={1}
          min={new Date(0, 0, 0, 7, 0, 0)}
          max={new Date(0, 0, 0, 22, 0, 0)}
          eventPropGetter={eventPropGetter}
          components={{
            event: handleRenderLessonEvent,
            agenda: {
              event: AgendaEventRender,
              date: ({ label, day }) => (
                <div
                  style={{
                    fontSize: "13px",
                    // color: "#1976d2",
                    padding: "10px 0",
                    display: "flex",
                    flexDirection: "column",
                  }}>
                  {moment(day).format("D MMMM")}
                </div>
              ),
              time: ({ label }) => <div style={{}}>{label}</div>,
            },
          }}
          culture="ru"
          messages={{
            next: "Вперед",
            previous: "Назад",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            agenda: "Список занятий",
            noEventsInRange: <EpmtyAgenda />,
          }}
        />
      </div>
    </div>
  );
}
